import { render, staticRenderFns } from "./Reportes.vue?vue&type=template&id=483315d6&scoped=true"
import script from "./Reportes.vue?vue&type=script&lang=js"
export * from "./Reportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483315d6",
  null
  
)

export default component.exports